import React, { PropsWithChildren, ReactElement, useMemo } from 'react';
import { Col, FlexboxGrid } from 'rsuite';
import LabelWithInfoIcon from '../../common/LabelWithInfoIcon';

interface BucketItemProps {
  label: string;
  dark?: boolean;
  description?: string;
}

export const BucketItem = ({
  dark,
  label,
  description,
  children,
}: PropsWithChildren<BucketItemProps>): ReactElement => {
  const gridStyles = useMemo(() => {
    const styles = {
      padding: '6px 8px',
      minHeight: '55px',
    };
    if (dark) {
      return {
        ...styles,
        background: '#f5f5f5',
      };
    }
    return styles;
  }, [dark]);
  return (
    <FlexboxGrid
      style={gridStyles}
      justify="space-between"
      align="middle"
    >
      <FlexboxGrid.Item
        colspan={24}
        as={Col}
        md={16}
        sm={12}
        xs={12}
        style={{ display: 'flex', gap: '8px' }}
      >
        <LabelWithInfoIcon
          label={label}
          infoText={description}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        colspan={24}
        as={Col}
        md={8}
        sm={12}
        xs={12}
      >
        {children}
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};
